module.exports = __webpack_public_path__ + "static/media/bitcoin-server.a322202f.gif";